import { AUDIT_SCHEMA_QUESTIONS } from "@/content/auditCopy";
import { OG_IMAGE, ORG_ID, abs } from "@/content/siteConfig";

// Kept apart from AuditPage so route head() code does not pull the whole page into the shared bundle.
const TITLE = "Free Conversion Tracking Audit | Google Ads, GA4 & Meta";
const DESCRIPTION =
  "Free conversion tracking audit: see which Google Ads, GA4 and Meta tags actually fire on any site in about 15 seconds. Need a full audit service? We do that too.";
const URL = abs("/audit");
const META_DESCRIPTION = "Free conversion tracking audit: see which Google Ads, GA4 and Meta tags actually fire on any site in about 15 seconds.";

export const auditHead = () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: META_DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: META_DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          name: "Conversion Tracking Audit",
          applicationCategory: "BusinessApplication",
          url: URL,
          description: DESCRIPTION,
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
          },
          provider: { "@id": ORG_ID },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: AUDIT_SCHEMA_QUESTIONS.map(f => ({
            "@type": "Question", name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          name: "Conversion Tracking Audit",
          serviceType: "Conversion tracking audit",
          provider: { "@id": ORG_ID },
          areaServed: [
            { "@type": "Place", name: "Phoenix metro area" },
            { "@type": "State", name: "Arizona" },
          ],
        }),
      },
    ],
});
